import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { Link } from '@mui/material';
import { alpha } from '@mui/material/styles';

export function ReviewEvidenceButton({
  onClick,
  label = 'Review evidence',
  compact = false,
  accent,
}: {
  onClick: () => void;
  label?: string;
  compact?: boolean;
  accent?: string;
}) {
  return (
    <Link
      component="button"
      type="button"
      variant="body2"
      underline="hover"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={`${label} — open verification brief`}
      sx={(theme) => {
        const color =
          accent ?? (theme.palette.mode === 'light' ? theme.palette.primary.dark : theme.palette.primary.light);
        return {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.35,
          fontWeight: 700,
          fontSize: compact ? '0.75rem' : '0.8125rem',
          color,
          '&:hover': {
            color: accent ? alpha(color, 0.82) : theme.palette.primary.main,
          },
          '&:focus-visible': {
            outline: `2px solid ${color}`,
            outlineOffset: 2,
            borderRadius: 1,
          },
        };
      }}
    >
      {label}
      <ArrowForwardRoundedIcon sx={{ fontSize: compact ? 14 : 16 }} />
    </Link>
  );
}
